import * as React from 'react'
import { ReactElement} from 'react'
import {Lang} from 'yougile-lang'
import {Hub} from 'yougile-model'
import {Menu, MenuItemData} from '@components/common/base/menu'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {ColConfig, SortType} from '@components/common/sandbox/list-view/types'

const getOrderOptions = (type: SortType, callback: (asc: boolean) => void): MenuItemData[] => {
  switch (type) {
    case SortType.Date:
      return [
        {
          id: 'asc',
          icon: 'IconArrowUp',
          title: Lang.msg.columnOrder.orderByOld,
          onClick: () => callback(true)
        },
        {
          id: 'desc',
          icon: 'IconArrowDown',
          title: Lang.msg.columnOrder.orderByNew,
          onClick: () => callback(false)
        }
      ]
    case SortType.Alphabetical:
      return [
        {
          id: 'asc',
          icon: 'IconSortAZ',
          title: Lang.msg.columnOrder.orderByAZ,
          onClick: () => callback(true)
        },
        {
          id: 'desc',
          icon: 'IconSortZA',
          title: Lang.msg.columnOrder.orderByZA,
          onClick: () => callback(false)
        }
      ]
    case SortType.Deadline:
      return [
        {
          id: 'asc',
          icon: 'IconArrowUp',
          title: Lang.msg.columnOrder.orderByOld,
          onClick: () => callback(true)
        },
        {
          id: 'desc',
          icon: 'IconArrowDown',
          title: Lang.msg.columnOrder.orderByNew,
          onClick: () => callback(false)
        }
      ]
    case SortType.Completion:
      return [
        {
          id: 'asc',
          icon: 'IconSortAscending2',
          title: Lang.msg.columnOrder.orderFirstCompleted,
          onClick: () => callback(true)
        },
        {
          id: 'desc',
          icon: 'IconSortDescending2',
          title: Lang.msg.columnOrder.orderFirstUnfulfilled,
          onClick: () => callback(false)
        }
      ]
    case SortType.Favorites:
      return [
        {
          id: 'asc',
          icon: 'IconStar',
          title: Lang.msg.myTasks.columnOrder.favoritesFirst,
          onClick: () => callback(true)
        },
        {
          id: 'desc',
          icon: 'IconStar',
          title: Lang.msg.myTasks.columnOrder.favoritesLast,
          onClick: () => callback(false)
        }
      ]
    default:
      return [
        {
          id: 'asc',
          icon: 'IconArrowUp',
          title: Lang.msg.columnOrder.orderByOld,
          onClick: () => callback(true)
        },
        {
          id: 'desc',
          icon: 'IconArrowDown',
          title: Lang.msg.columnOrder.orderByNew,
          onClick: () => callback(false)
        }
      ]
  }
}

const getSortMenu = (
  columns: ColConfig<Hub>[],
  onSetNewOrder: (column: string, asc: boolean) => void
): MenuItemData[] => {
  return columns
    .filter(column => column.sort)
    .map(column => {
      /*
      Typescript can't understand that filtering column by sort field guaranties that sort field is not undefined
      and throws error TS2532: Object is possibly undefined. Assertion is needed to avoid that typescript error
      but rule no-unnecessary-type-assertion thinks that it's unnecessary.Therefore, rule have to be disabled next line
      */
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      const sort = column.sort as NonNullable<ColConfig<Hub>['sort']>;
      return {
        id: column.id,
        icon: sort.icon as TablerIcons,
        title: sort.title,
        items: getOrderOptions(sort.type, asc => onSetNewOrder(column.id, asc))
      }
  });
}

interface SortMenuDropdownProps {
  children?: ReactElement | undefined;
  columns: ColConfig<Hub>[];
  reference: React.RefObject<Element> | Element | null;
  isOpened: boolean;
  closeMenu: () => void;
  onSetNewOrder: (column: string, asc: boolean) => void;
}

export const SortMenuDropdown = (props: SortMenuDropdownProps) => {
  const {
    children,
    columns,
    reference,
    isOpened,
    closeMenu,
    onSetNewOrder
  } = props;

  const menuItems: MenuItemData[] = getSortMenu(columns, onSetNewOrder)

  return (
    <Dropdown
      reference={reference}
      placement="bottom"
      hideArrow
      content={<Menu items={menuItems} onItemClicked={closeMenu} />}
      visible={isOpened}
      onVisibleChange={closeMenu}
      theme="new-menu"
    >
      {children}
    </Dropdown>
  )
};